import { Component ,Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { DataServiceService } from '../data-service.service';
import { CampusTrackService } from '../campus-track.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-dialogcampus',
  templateUrl: './dialogcampus.component.html',
  styleUrls: ['./dialogcampus.component.scss']
})
export class DialogcampusComponent implements OnInit{
  campusTrack!: FormGroup;
  campus: any;
  listBy: string = 'PENDING';
  filteredCampus: Observable<string[]>;
  options: any;

  obj: any;
  classList: any[];
  classWiseStreams: any[];
  classData: any;
  selectedClass: any;
  temp: any[];
  // dialogRef: any;
  data: any;
  selectedOptionId: any
  filteredOptions: Observable<any>;
  list: any;
  filterParams: any;
  //  cname=this.dialogdata.getCampusName()
  //  clasname=this.dialogdata.getClassName( )
  //  streamname=this.dialogdata.getStreamName()

  Campus: any = new FormControl();
  Class1: any = new FormControl();
  Stream1: any = new FormControl()

  campusname: any;
  Class: any;
  Stream: any;

  classNames: any;
  mediums: any;
  group: any;
  selectId: any;
  dialogRef12: MatDialogRef<DialogcampusComponent, any>;
  editdialog: any = false;
  selectedCourseTrackId: any;
  campuslist: any;
  campusdetails: any;
  load: any;
  show = true;

  data1: any = {};  
  campuses: any[] = [];
  cam: any;
  campusName: any;
  className: any;
  streamname: any;
  classId: any;
  StreamID: any;
  @ViewChild('matSelect') matSelect: MatSelect;
  constructor(private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data12: any, private course: CampusTrackService, public dialogRef: MatDialogRef<DialogcampusComponent>, private dialog1: NgDialogAnimationService,public snackbar: MatSnackBar, private spinner: NgxSpinnerService ) { }
  ngOnInit(): void {

    this.campusTrack = this.fb.group({
      campusname: [" ", Validators.required],
      Class: [" ", Validators.required],
      Stream: [" ", Validators.required]
    })
    this.getdata()
    this.getclass1()
    this.getpending()
    // this.campusdata()


  }
  // private _filter(value: string): any[] {
  //   const filterValue = value.toLowerCase();
  //   return this.campusname.filter((option: any) => option.campusName.toLowerCase().includes(filterValue));
  
  // }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  private _filter1(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.Class.filter((option: any) => option.displayName.toLowerCase().includes(filterValue));
  }
  private _filter2(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.Stream.filter((option: any) => option.streamName.toLowerCase().includes(filterValue));
  }


  getdata() {
    this.spinner.show()
    this.course.getcampus().subscribe((res: any) => {
      this.options = res;
      this.campus = res;
      this.spinner.hide()
      this.classNames = this.Campus!.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campus, "campusName") || '')
      );
      console.log(this.campus);
    })


  }
  getclass1() {
    this.spinner.show()
    this.course.getclass().subscribe((res: any) => {
      this.classList = res.classList;
      this.classWiseStreams = res.classWiseStreams;
      this.spinner.hide()
      this.mediums = this.Class1!.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.classList, "displayName") || '')
      );

    })
  }

  filterCampus(enteredData: any) {
    this.selectId = enteredData.campusId
    this.campusName = enteredData.campusName
   

  }
  getClassStreams(data: any) {
    this.className = data.className
    this.classId = data.id
    this.temp = [];


    // this.temp = this.classWiseStreams
    //   .filter(streamData => streamData.classId === classId)[0].StreamList;
    for (let i = 0; i < this.classWiseStreams.length; i++) {
      if (this.classWiseStreams[i].classId == this.classId) {
        this.temp = this.classWiseStreams[i].StreamList
      }
    }
    console.log(this.classList);

    this.group = this.Stream1!.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.Filter(value, this.temp, "streamName") || '')
    );
  }
  // getpending() {
  //   this.course.getcampuspendinglist(this.listBy).subscribe((res: any) => {
  //     this.list = res
  //     $('#example').DataTable().destroy()
  //     $(document).ready(() => {
  //       $('#example').DataTable({
  //         scrollX: true 
  //       });
  //     });
  //   })
  //   console.log("pending", this.list);
  // }

  opendialog() {
    // this.show=!this.show;
    this.data1 = {
      selectedcampus: this.selectId,
      selectedClass: this.campusTrack.value.Class,
      selectedstream: this.campusTrack.value.Stream
    }
    if (this.campusTrack.valid) {
      this.show = !this.show;
      this.campusdata()
    } else {
      window.alert("please enter all flied")
    }
  }
  pending(filterParams: any) {
    this.spinner.show()
    this.course.getcampuspendinglist(filterParams).subscribe((res: any) => {
      this.list = res;
      this.spinner.hide()
      $('#example').DataTable().destroy();
      $(document).ready(() => {
        $('#example').DataTable({
          scrollX: true
        });
      });

    });
  }
  campusdialog(report: any) {
    this.data = report
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value == 'REJECTED') {
        this.pending(value)
      }
      else if (value == 'APPROVED') {
        this.pending(value)
      } else {
        $('#example').DataTable().destroy();
        this.getpending()
      }
    })

  }
  // closedialog() {
  //   this.dialogRef.close()
  // }

  campusdata() {
    this.spinner.show()
    this.course.getcampusdata(this.classId, this.StreamID, this.selectId).subscribe(res => {
      this.campuslist = res
      this.spinner.hide()
      console.log(this.campuslist);
      console.log(this.campuslist?.[0]?.courseTrackId);
      this.selectedCourseTrackId = this.campuslist[0]?.courseTrackId
      this.course.getdetails(this.selectedCourseTrackId).subscribe(res => {
        console.log(res);
        this.campusdetails = res
      })
    })
  }
  setStream(data: any) {
    this.streamname = data.streamName
    this.StreamID = data.streamId
  }
  details(event: any) {
    this.selectedCourseTrackId = event.target.value;
    this.course.getdetails(this.selectedCourseTrackId).subscribe(res => {
      this.campusdetails = res
      console.log(this.campusdetails);

    })
  }

  save() {
    let payload = {
      "courseTrackId": this.selectedCourseTrackId,
      "campusId": this.data1.selectedcampus
    }
    this.course.getcampussave(payload).subscribe(res => {
      this.load = res
      this.show = !this.show;
      this.deitles()
      this.snackbar.open('Course Track Details Saved Successfully ', 'Close', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'end',
      });
    })
  }
  // close() {
  //   this.dialogRef.close();
  // }

  deitles() {
    // this.campusTrack.patchValue({
    //   Campus: this.campusName,
    //   Class1: this.className,
    //   Stream1: this.streamname,
    // })
    this.Campus?.setValue(this.campusName)
    this.Class1?.setValue(this.className)
    this.Stream1?.setValue(this.streamname)
  }
  getpending() {
    this.spinner.show()
    this.course.getcampuspendinglist(this.listBy).subscribe((res: any) => {
      this.list = res
      this.spinner.hide()
      $('#example').DataTable().destroy()
      $(document).ready(() => {
        $('#example').DataTable({
          scrollX: true
        });
      });
    })
    console.log("pending", this.list);
  }
  Campusinput(select: MatSelect){
    this.Campus.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Class1input(select: MatSelect){
    this.Class.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Stream1input(select: MatSelect){
    this.Class.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
}


